import { FC, useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import ButtonComponent from '../formlib/ButtonComponent';
import DropdownComponent from '../formlib/DropdownComponent';
import MediumTypography from '../formlib/MediumTypography';
import { OptionType } from '../../utils/type';

export const DOWNLOAD_LANGUAGE_OPTIONS: OptionType[] = [
  { id: 'en', label: 'English (Default)' },
  { id: 'ht', label: 'Haitian Creole' },
  { id: 'pt', label: 'Portuguese' },
  { id: 'es', label: 'Spanish' },
];

const DEFAULT_LANGUAGE = 'en';

interface LanguageSelectionDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (languageCode: string) => void;
  languageOptions?: OptionType[];
  messageLabelId?: string;
  messageDefaultLabel?: string;
  dropdownLabelId?: string;
  dropdownDefaultLabel?: string;
}

const LanguageSelectionDialog: FC<LanguageSelectionDialogProps> = ({
  open,
  onClose,
  onConfirm,
  languageOptions = DOWNLOAD_LANGUAGE_OPTIONS,
  messageLabelId = 'IFSP.DownloadLanguagePrompt',
  messageDefaultLabel = 'In which language do you prefer to download this form?',
  dropdownLabelId = 'IFSP.DownloadLanguageLabel',
  dropdownDefaultLabel = 'Language',
}) => {
  const [selectedLanguage, setSelectedLanguage] =
    useState<string>(DEFAULT_LANGUAGE);

  useEffect(() => {
    if (open) {
      setSelectedLanguage(DEFAULT_LANGUAGE);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="xs"
      keepMounted
      onClose={(_, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
        onClose();
      }}
    >
      <DialogContent>
        <MediumTypography
          labelid={messageLabelId}
          defaultlabel={messageDefaultLabel}
          textColor="var(--thom-dark-green-table-black)"
          className="mb-md font-bold"
        />
        <DropdownComponent
          names={languageOptions}
          value={selectedLanguage}
          handleChange={(value: string) => setSelectedLanguage(value)}
          labelid={dropdownLabelId}
          defaultlabelid={dropdownDefaultLabel}
          disableClearable
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'flex-end', marginBottom: '16px' }}>
        <ButtonComponent
          className="btn-primary btn-cancel mr-md"
          labelId="Clientpage.Nobtn"
          defaultLabelId="No"
          variantType="outlined"
          onClick={onClose}
        />
        <ButtonComponent
          className="btn-primary btn-submit mr-md"
          labelId="Clientpage.Yesbtn"
          defaultLabelId="Yes"
          variantType="contained"
          onClick={() => onConfirm(selectedLanguage)}
        />
      </DialogActions>
    </Dialog>
  );
};

export default LanguageSelectionDialog;
